import { t } from 'i18next'
import { Dropdown, DropdownChangeParams } from 'primereact/dropdown'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { ConfessionCT } from '../../../../../model/enums/enums'
import { Confession } from '../../../../../util/confession'

const confessionList: Confession[] = [
  { label: 'hrm.confession.no_religion', value: ConfessionCT.NoReligion },
  { label: 'hrm.confession.roman_catholic', value: ConfessionCT.RomanCatholic },
  {
    label: 'hrm.confession.other_christian',
    value: ConfessionCT.OtherChristian,
  },
  { label: 'hrm.confession.reformed', value: ConfessionCT.Reformed },
  { label: 'hrm.confession.judaism', value: ConfessionCT.Judaism },
  { label: 'hrm.confession.hinduism', value: ConfessionCT.Hinduism },
  { label: 'hrm.confession.islam', value: ConfessionCT.Islam },
  { label: 'hrm.confession.buddhism', value: ConfessionCT.Buddhism },
  { label: 'hrm.confession.confucianism', value: ConfessionCT.Confucianism },
  { label: 'hrm.confession.taoism', value: ConfessionCT.Taoism },
  { label: 'hrm.confession.sikhism', value: ConfessionCT.Sikhism },
  { label: 'hrm.confession.other', value: ConfessionCT.Other },
]

export const ConfessionDropdown = () => {
  const { control } = useFormContext()

  const translatedLable = (option: Confession) => {
    return option?.label ? t<string>(option.label) : t<string>('core.select')
  }

  return (
    <Controller
      name="confession"
      control={control}
      render={({ field }) => (
        <Dropdown
          id={'ConfessionDropdown'}
          appendTo={document.body}
          value={field.value || ''}
          valueTemplate={translatedLable}
          itemTemplate={translatedLable}
          options={confessionList}
          placeholder={t<string>('core.select')}
          onChange={(changeParams: DropdownChangeParams) => {
            field.onChange(changeParams.value)
          }}
        />
      )}
    />
  )
}